module.exports = __webpack_public_path__ + "media/images/home-9859f5783861e5572fe3e7920dc03d65.png";